import React, { Component } from 'react'
import PropTypes from 'prop-types';
// import { Tab, Tabs } from 'react-bootstrap';
// import { DataWrapperClass } from '../../../../screens/settings/ContactListPrivate/styles'
import { ActivityTitle, CustomTabs, TagsStyle, Timeline, UserInfo, UserNote, UserTag } from '../styles/main';

export class ContactInfoActivityTheme extends Component {

    constructor(props) {
        super(props);
        this.open = this.open.bind(this);
        this.state = {
            isActive: false,
            list: [
                {
                    tags: ['In Complete', 'Implemented', 'In Progress'],
                    date: "May 22",
                    img: "/images/userImg.png",
                    name: "Henry Evans",
                    type: "Inbound Call",
                    time: "09:00 AM",
                    note: "Contrary to popular belief, Lorem Ipsum is not simply random text...",
                    viewMore: "Contrary to popular belief, Lorem Ipsum is not simply random text..."
                }
            ]
        };
    }

    open() {
        if (this.state.isActive) {
            this.setState({ isActive: false });
        } else {
            this.setState({ isActive: true });
        }

    }

    renderData(date, img, name, type, time, tags, note, viewMore) {
        const { __ } = this.context;
        return (
            <li className='rs-timeline-item'>
                <span className='rs-timeline-item-tail'></span>
                <span className='rs-timeline-item-dot'></span>
                <div className='rs-timeline-item-content'>
                    <p style={{ display: 'flex', whiteSpace: 'nowrap', borderBottom: '0.7px dashed #ddd', paddingBottom: '15px' }}>
                        <span className='date'>{__(date)}</span>
                        <span style={{ width: '100%' }}>
                            <UserInfo>
                                <img src={img} />
                                <h6>{name}</h6>
                                <span>{type}</span>
                                <span className='time'>{time}</span>
                            </UserInfo>
                            <UserTag>
                                <span>TAG: </span>
                                {tags}
                            </UserTag>
                            <UserNote>
                                <span>NOTE: </span>
                                <h6>{note}</h6>
                                <h5 onClick={() => this.open()}>View More</h5>
                            </UserNote>
                            {viewMore}
                        </span>
                    </p>
                </div>
            </li>
        )
    }

    render() {
        return (
            // <DataWrapperClass style={{ background: '#fff', borderRadius: '5px', marginBottom: '25px', overflowY: 'auto', height: '450px' }}>
            //     <CustomTabs>
            //         <Tabs
            //             defaultActiveKey="activity"
            //             id="uncontrolled-tab-example"
            //             className="customTabs"
            //         >
            //             <Tab eventKey="activity" title="ACTIVITY">
            //                 <Timeline>
            //                     <ActivityTitle>May 2022</ActivityTitle>
            //                     <ul className='rs-timeline rs-timeline-align-left'>
            //                         {this.renderData(
            //                              this.state.list[0].date,
            //                              this.state.list[0].img,
            //                              this.state.list[0].name,
            //                              this.state.list[0].type,
            //                              this.state.list[0].time,
            //                              this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                              this.state.list[0].note,
            //                              this.state.isActive && this.state.list[0].viewMore,
            //                         )}
            //                         {this.renderData(
            //                             this.state.list[0].date,
            //                             this.state.list[0].img,
            //                             this.state.list[0].name,
            //                             this.state.list[0].type,
            //                             this.state.list[0].time,
            //                             this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                             this.state.list[0].note,
            //                             this.state.list[0].viewMore,
            //                         )}
            //                         {this.renderData(
            //                             this.state.list[0].date,
            //                             this.state.list[0].img,
            //                             this.state.list[0].name,
            //                             this.state.list[0].type,
            //                             this.state.list[0].time,
            //                             this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                             this.state.list[0].note,
            //                             this.state.list[0].viewMore,
            //                         )}
            //                     </ul>
            //                 </Timeline>
            //                 <Timeline>
            //                     <ActivityTitle>February 2022</ActivityTitle>
            //                     <ul className='rs-timeline rs-timeline-align-left'>
            //                         {this.renderData(
            //                             this.state.list[0].date,
            //                             this.state.list[0].img,
            //                             this.state.list[0].name,
            //                             this.state.list[0].type,
            //                             this.state.list[0].time,
            //                             this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                             this.state.list[0].note,
            //                             this.state.list[0].viewMore,
            //                         )}
            //                         {this.renderData(
            //                             this.state.list[0].date,
            //                             this.state.list[0].img,
            //                             this.state.list[0].name,
            //                             this.state.list[0].type,
            //                             this.state.list[0].time,
            //                             this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                             this.state.list[0].note,
            //                             this.state.list[0].viewMore,
            //                         )}
            //                         {this.renderData(
            //                             this.state.list[0].date,
            //                             this.state.list[0].img,
            //                             this.state.list[0].name,
            //                             this.state.list[0].type,
            //                             this.state.list[0].time,
            //                             this.state.list[0].tags.map((item) => <TagsStyle className='bg-info'>{item}</TagsStyle>),
            //                             this.state.list[0].note,
            //                             this.state.list[0].viewMore,
            //                         )}
            //                     </ul>
            //                 </Timeline>
            //             </Tab>
            //             <Tab eventKey="notes" title="NOTES">

            //             </Tab>
            //         </Tabs>
            //     </CustomTabs>
            // </DataWrapperClass>
            <React.Fragment></React.Fragment>
        )
    }
}

ContactInfoActivityTheme.contextTypes = {
    __: PropTypes.func
};

export default ContactInfoActivityTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ContactInfoActivityTheme.js